import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Link as RouterLink } from 'react-router-dom'; // Import Router, Routes, Route, and RouterLink
import DownloadPage from './components/DownloadPage';
import userImage from './assets/profile.jpeg';





// --- ICONS ---
const Icon = ({ children, ...props }) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{children}</svg>;
const MailIcon = (props) => <Icon {...props}><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></Icon>;
const GithubIcon = (props) => <Icon {...props}><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path></Icon>;
const LinkedinIcon = (props) => <Icon {...props}><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></Icon>;
const ClipboardIcon = (props) => <Icon {...props}><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path></Icon>;
const CheckIcon = (props) => <Icon {...props}><polyline points="20 6 9 17 4 12"></polyline></Icon>;
const MenuIcon = (props) => <Icon {...props}><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></Icon>;
const XIcon = (props) => <Icon {...props}><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></Icon>;
const ArrowUpIcon = (props) => <Icon {...props}><line x1="12" y1="19" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline></Icon>;

export const SparkleIcon = (props) => ( // Export SparkleIcon to be used in DownloadPage
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 0L7.06066 4.93934L12 6L7.06066 7.06066L6 12L4.93934 7.06066L0 6L4.93934 4.93934L6 0Z" fill="currentColor" />
  </svg>
);


// --- VISUAL EFFECTS ---
const useSparkles = (defaultColor = 'white') => {
  const [sparkles, setSparkles] = useState([]);
  const sparkleLifetime = 1000;
  useEffect(() => {
    const onMouseMove = (e) => { setSparkles(cs => [...cs, { id: Date.now(), x: e.clientX, y: e.clientY, color: defaultColor, createdAt: Date.now() }]); };
    window.addEventListener('mousemove', onMouseMove);
    const interval = setInterval(() => { const now = Date.now(); setSparkles(cs => cs.filter(s => now - s.createdAt < sparkleLifetime)); }, 200);
    return () => { window.removeEventListener('mousemove', onMouseMove); clearInterval(interval); };
  }, [defaultColor]);
  return sparkles;
};


const CursorSparkles = () => {
  const sparkles = useSparkles();
  const now = Date.now();
  return (
    <div className="pointer-events-none fixed inset-0 z-50 hidden md:block">
      {sparkles.map(sparkle => {
        const age = now - sparkle.createdAt;
        const opacity = Math.max(0, 1 - age / 1000);
        const scale = Math.max(0, 1 - age / 1000);
        return <div key={sparkle.id} className="absolute" style={{ top: sparkle.y, left: sparkle.x, transform: `translate(-50%, -50%) scale(${scale})`, opacity: opacity, color: sparkle.color }}><SparkleIcon /></div>
      })}
    </div>
  );
};

const ParticleCanvas = () => {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let particles = []; let stars = []; let animationFrameId;
    const resizeCanvas = () => { canvas.width = window.innerWidth; canvas.height = window.innerHeight; };
    class Particle {
      constructor(x, y, vx, vy) { this.x = x; this.y = y; this.vx = vx; this.vy = vy; this.radius = (Math.random() * 1.5 + 0.5) * 2.5; this.color = `rgba(255, 255, 255, ${Math.random() * 0.2 + 0.05})`; }
      draw() { ctx.fillStyle = this.color; ctx.beginPath(); ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2); ctx.fill(); }
      update() { this.x += this.vx; this.y += this.vy; if (this.x < 0 || this.x > canvas.width) this.vx *= -1; if (this.y < 0 || this.y > canvas.height) this.vy *= -1; this.draw(); }
    }
    class Star {
      constructor(x, y, radius, opacity) { this.x = x; this.y = y; this.radius = radius; this.opacity = opacity; this.vy = 0.05; }
      draw() { ctx.beginPath(); ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2); ctx.fillStyle = `rgba(229, 231, 235, ${this.opacity})`; ctx.fill(); }
      update() { this.y += this.vy; if (this.y > canvas.height + this.radius) { this.y = -this.radius; this.x = Math.random() * canvas.width; } this.draw(); }
    }
    class SparkleParticle extends Star {
      constructor(x, y, radius) { super(x, y, radius, 0); this.maxOpacity = Math.random() * 0.5 + 0.2; this.twinkleSpeed = Math.random() * 0.03 + 0.01; this.phase = Math.random() * Math.PI * 2; }
      update() { this.opacity = this.maxOpacity * (Math.sin(this.phase + performance.now() * 0.001 * this.twinkleSpeed) * 0.5 + 0.5); this.draw(); }
    }
    const createParticles = () => {
      particles = []; stars = [];
      const particleCount = Math.floor(canvas.width * canvas.height / 30000);
      for (let i = 0; i < particleCount; i++) { particles.push(new Particle(Math.random() * canvas.width, Math.random() * canvas.height, (Math.random() - 0.5) * 0.2, (Math.random() - 0.5) * 0.2)); }
      const starCount = 50; const sparkleCount = 25;
      for (let i = 0; i < starCount; i++) { const radius = Math.random() * (i > starCount - 5 ? 2.5 : 1.5) + 0.3; stars.push(new Star(Math.random() * canvas.width, Math.random() * canvas.height, radius, Math.random() * 0.5 + 0.1)); }
      for (let i = 0; i < sparkleCount; i++) { const radius = Math.random() * 1.2 + 0.4; stars.push(new SparkleParticle(Math.random() * canvas.width, Math.random() * canvas.height, radius)); }
    };
    const animate = () => { if (!canvas.getContext) return; ctx.clearRect(0, 0, canvas.width, canvas.height); particles.forEach(p => p.update()); stars.forEach(s => s.update()); animationFrameId = requestAnimationFrame(animate); };
    resizeCanvas(); createParticles(); animate();
    const handleResize = () => { resizeCanvas(); createParticles(); };
    window.addEventListener('resize', handleResize);
    return () => { window.removeEventListener('resize', handleResize); cancelAnimationFrame(animationFrameId); };
  }, []);
  return <canvas ref={canvasRef} className="absolute top-0 left-0 w-full h-full z-0" />;
};


// --- DATA ---
const portfolioData = {
  skills: ["JavaScript", "React.js", "HTML5", "CSS3", "Tailwind CSS", "Node.js", "Git", "Problem-Solving", "Adobe Photoshop", "Microsoft Excel", "Clip Studio Paint", "Adaptive Design"],
  projects: [
    { title: "Techno-Chat", description: "A real-time web chat application built with PHP and JavaScript.", tags: ["PHP", "JavaScript", "AJAX"], link: "https://github.com/Karanveerkvr/Techno-Chat" },
    { title: "Birthday Wish Website", description: "A Birthday wishing website built using HTML, JavaScript and Tailwind CSS.", tags: ["HTML", "Javacript", "Tailwind CSS"], link: "https://karanveerkvr.github.io/Tortol/" },
    { title: "IRL Quest", description: "A Quest Log application with gamified ui and interaction, built mostly with JavaScript. Which helps people keep track of their task", tags: ["HTML", "JavaScript", "CSS"], link: "/download-irl-quest" }, // Changed link to new download page
    { title: "Fresher Jobs", description: "A Website to look for jobs built with HTML, CSS and JavaScript.", tags: ["HTML", "JavaScript", "CSS"], link: "https://karanveerkvr.github.io/Fresher-Job/" },
  ],
  experience: [
    { role: "Website Developer & Graphics Designer", company: "Freelance", date: "Jan 2022 - Present", desc: "Brought brands to life with captivating logos and web designs, helping local and small businesses shine, shatter expectations, and soar to new heights!" },
    { role: "Frontend Developer", company: "SoftiCation Technology", date: "Aug 2022 - Jan 2023", desc: "Collaborated within a development team to build and maintain user-facing features for various web applications." },
    { role: "Game Server Mod Developer", company: "GAMESTARS LTD", date: "May 2022 - Aug 2022", desc: "Developed server-sided modlets to enhance player experience, fixed gameplay bugs, and resolved security issues as part of a tech team." }
  ],
  education: [
    { institution: "Dr. Virendra Swarup Institute of Computer Studies, Kanpur", degree: "Bachelor's degree, Computer Programming" },
  ],
  certifications: ["Full-Stack Web Developer", "DevOps Foundations", "Node.js Essential Training", "Git Essential Training"]
};

// --- UI COMPONENTS ---
const ScrollIndicator = ({ sections, activeIndex, onIndicatorClick }) => (
  <div className="fixed right-0 top-1/2 -translate-y-1/2 z-40 pr-4 hidden md:flex flex-col gap-4">
    {sections.map((section, index) => (
      <button key={section} onClick={() => onIndicatorClick(index)} className="flex items-center gap-3 justify-end group focus:outline-none">
        <span className={`text-xs uppercase transition-all duration-300 ${activeIndex === index ? 'text-gray-300 opacity-100' : 'text-gray-600 opacity-0 group-hover:opacity-70'}`}>{section}</span>
        <div className={`w-1.5 h-1.5 rounded-full transition-all duration-300 ${activeIndex === index ? 'bg-gray-200 scale-150 shadow-[0_0_10px_rgba(255,255,255,0.5)]' : 'bg-gray-700 group-hover:bg-gray-500'}`}></div>
      </button>
    ))}
  </div>
);


// --- SECTIONAL COMPONENTS ---
const Header = ({ scrollToSection, activeSection }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const navLinks = [
    { id: 'about', label: 'About' },
    { id: 'work', label: 'Work' },
    { id: 'irl-quest', label: 'IRL Quest App', path: '/download-irl-quest' }, // Add this line
    { id: 'contact', label: 'Contact' }
  ];
  useEffect(() => { const handleScroll = () => setShowBackToTop(window.scrollY > 300); window.addEventListener('scroll', handleScroll); return () => window.removeEventListener('scroll', handleScroll); }, []);
  const NavLink = ({ id, label, path }) => { // Add 'path' to props
    const isActive = activeSection === id || (path && window.location.pathname === path); // Logic for active state

    if (path) {
      return (
        <RouterLink
          to={path}
          onClick={() => setIsMenuOpen(false)} // Close menu on click
          className={`relative text-sm font-light uppercase tracking-widest transition-colors duration-300 ${isActive ? 'text-white' : 'text-gray-400 hover:text-white'}`}
        >
          {label}
          <span className={`absolute bottom-[-4px] left-0 h-[1px] bg-white transition-all duration-300 ${isActive ? 'w-full' : 'w-0'}`}></span>
        </RouterLink>
      );
    } else {
      return (
        <a
          href={`#${id}`}
          onClick={(e) => { e.preventDefault(); scrollToSection(id); setIsMenuOpen(false); }}
          className={`relative text-sm font-light uppercase tracking-widest transition-colors duration-300 ${isActive ? 'text-white' : 'text-gray-400 hover:text-white'}`}
        >
          {label}
          <span className={`absolute bottom-[-4px] left-0 h-[1px] bg-white transition-all duration-300 ${isActive ? 'w-full' : 'w-0'}`}></span>
        </a>
      );
    }
  };
  return (
    <>
      <header className="fixed top-0 left-0 w-full bg-black/50 backdrop-blur-md z-40">
        <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
          <RouterLink to="/" onClick={() => scrollToSection('home')} className="text-xl font-medium text-white transition-colors duration-300">KVR</RouterLink> {/* Changed to RouterLink */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map(link => <NavLink key={link.id} {...link} />)}
            <button onClick={() => scrollToSection('home')} className={`transition-all duration-300 text-gray-400 hover:text-white ${showBackToTop ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}><ArrowUpIcon className="w-5 h-5" /></button>
          </div>
          <div className="md:hidden"><button onClick={() => setIsMenuOpen(true)} className="text-gray-300 hover:text-white"><MenuIcon /></button></div>
        </nav>
      </header>
      <div className={`fixed inset-0 bg-black/90 backdrop-blur-lg z-50 flex flex-col items-center justify-center gap-8 transition-opacity duration-300 md:hidden ${isMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
        <button onClick={() => setIsMenuOpen(false)} className="absolute top-4 right-6 text-gray-400 hover:text-white"><XIcon /></button>
        {navLinks.map(link => (
          link.path ? (
            <RouterLink key={`mobile-${link.id}`} to={link.path} onClick={() => setIsMenuOpen(false)} className="text-2xl text-gray-300 hover:text-white">{link.label}</RouterLink>
          ) : (
            <a key={`mobile-${link.id}`} href={`#${link.id}`} onClick={(e) => { e.preventDefault(); scrollToSection(link.id); setIsMenuOpen(false); }} className="text-2xl text-gray-300 hover:text-white">{link.label}</a>
          )
        ))}
      </div>
    </>
  );
};

const Hero = () => (<section id="home" className="h-screen flex items-center justify-center relative bg-black"><ParticleCanvas /><div className="text-center z-10 p-4"><h1 className="text-4xl sm:text-5xl md:text-7xl font-semibold text-white mb-4 animate-[glow_8s_ease-in-out_infinite]">Karanveer Shukla</h1><p className="text-lg sm:text-xl md:text-2xl text-gray-300 font-light">Web Developer & Graphics Designer</p></div></section>);

const About = () => (
  <section id="about" className="container mx-auto px-6 sm:px-8 py-20 md:py-32 flex flex-col items-center">
    <h2 className="text-2xl sm:text-3xl font-medium text-gray-300 mb-12 self-start">// ABOUT ME</h2>
    <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16">
      <div className="w-48 h-48 md:w-60 md:h-60 flex-shrink-0 relative group"><div className="absolute inset-0 bg-gray-800 rounded-md transform -rotate-6 transition-transform duration-500 group-hover:rotate-0"></div><img src={userImage} alt="Karanveer Shukla" className="relative w-full h-full object-cover rounded-md shadow-2xl shadow-black/50" /></div>
      <p className="max-w-xl text-base md:text-lg text-gray-400 leading-relaxed text-center md:text-left">As a computer science student with a passion for problem-solving and a talent for web development, I bring a strong foundation in CSS, HTML, and JavaScript and a good understanding of React.js, and Node.js. With a dedication to detail and a keen eye for design, I am excited about using my skills to create user-friendly applications and make a meaningful impact in the tech industry.</p>
    </div>
  </section>
);

const HorizontalSection = React.forwardRef(({ data }, ref) => (
  <div ref={ref} className="md:flex">
    {/* Skills Section */}
    <div className="w-full h-auto md:w-screen md:h-screen flex flex-col items-center justify-center p-12 md:p-20 border-b border-gray-900 md:border-b-0">
      <h2 className="text-2xl sm:text-3xl font-medium text-gray-300 mb-12 w-full max-w-6xl">// SKILLS</h2>
      <div className="flex flex-wrap gap-3 sm:gap-4 justify-center w-full max-w-6xl">
        {data.skills.map(skill => (<div key={skill} className="bg-gray-900 border border-gray-800 rounded-md px-3 py-1.5 sm:px-4 sm:py-2 text-sm sm:text-base text-gray-300 hover:bg-white hover:text-black transition-colors duration-300 cursor-default">{skill}</div>))}
      </div>
    </div>
    {/* Projects Section */}
    <div className="w-full h-auto md:w-screen md:h-screen flex flex-col items-center justify-center p-12 md:p-20 border-b border-gray-900 md:border-b-0">
      <h2 className="text-2xl sm:text-3xl font-medium text-gray-300 mb-12 w-full max-w-6xl">// PROJECTS</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 w-full max-w-6xl">
        {data.projects.map(p => (
          // Use RouterLink for internal navigation, <a> for external links
          p.link.startsWith('/') ? (
            <RouterLink to={p.link} key={p.title} className="bg-gray-900 border border-gray-800 rounded-lg p-6 flex flex-col transition-all duration-300 hover:border-gray-600 hover:shadow-2xl hover:shadow-black/40 transform hover:-translate-y-2 h-full group">
              <h3 className="text-xl sm:text-2xl font-medium text-white mb-2">{p.title}</h3>
              <p className="text-gray-400 text-sm sm:text-base mb-4 flex-grow">{p.description}</p>
              <div className="flex flex-wrap gap-2 mb-4">{p.tags.map(tag => (<span key={tag} className="text-xs bg-gray-800 text-gray-400 px-2 py-1 rounded-full">{tag}</span>))}</div>
              <div className="text-gray-400 self-start mt-auto group-hover:text-white">View Project <span className="inline-block transform group-hover:translate-x-1 transition-transform">&rarr;</span></div>
            </RouterLink>
          ) : (
            <a href={p.link} target="_blank" rel="noopener noreferrer" key={p.title} className="bg-gray-900 border border-gray-800 rounded-lg p-6 flex flex-col transition-all duration-300 hover:border-gray-600 hover:shadow-2xl hover:shadow-black/40 transform hover:-translate-y-2 h-full group">
              <h3 className="text-xl sm:text-2xl font-medium text-white mb-2">{p.title}</h3>
              <p className="text-gray-400 text-sm sm:text-base mb-4 flex-grow">{p.description}</p>
              <div className="flex flex-wrap gap-2 mb-4">{p.tags.map(tag => (<span key={tag} className="text-xs bg-gray-800 text-gray-400 px-2 py-1 rounded-full">{tag}</span>))}</div>
              <div className="text-gray-400 self-start mt-auto group-hover:text-white">View Project <span className="inline-block transform group-hover:translate-x-1 transition-transform">&rarr;</span></div>
            </a>
          )
        ))}
      </div>
    </div>
    {/* Experience Section */}
    <div className="w-full h-auto md:w-screen md:h-screen flex flex-col items-center justify-center p-12 md:p-20 border-b border-gray-900 md:border-b-0">
      <h2 className="text-2xl sm:text-3xl font-medium text-gray-300 mb-12 w-full max-w-6xl">// EXPERIENCE</h2>
      <div className="space-y-8 max-w-3xl w-full">
        {data.experience.map(e => (<div key={e.company}><p className="text-sm text-gray-500 mb-1">{e.date}</p><h3 className="text-lg sm:text-xl font-medium text-white">{e.role} - <span className="text-gray-400 font-normal">{e.company}</span></h3><p className="text-gray-400 text-sm sm:text-base leading-relaxed">{e.desc}</p></div>))}
      </div>
    </div>
    {/* Education & Certs Section */}
    <div className="w-full h-auto md:w-screen md:h-screen flex flex-col items-center justify-center p-12 md:p-20">
      <h2 className="text-2xl sm:text-3xl font-medium text-gray-300 mb-12 w-full max-w-6xl">// EDUCATION</h2>
      <div className="grid md:grid-cols-2 gap-6 sm:gap-8 w-full max-w-4xl">
        <div className="bg-gray-900 border border-gray-800 rounded-lg p-6"><h3 className="text-lg sm:text-xl font-medium text-white mb-4">Education</h3>{data.education.map(e => (<div key={e.institution}><p className="font-semibold text-gray-300 text-sm sm:text-base">{e.institution}</p><p className="text-gray-400 text-sm sm:text-base">{e.degree}</p></div>))}</div>
        <div className="bg-gray-900 border border-gray-800 rounded-lg p-6"><h3 className="text-lg sm:text-xl font-medium text-white mb-4">Key Certifications</h3><ul className="space-y-2 list-disc list-inside text-gray-400 text-sm sm:text-base">{data.certifications.map(c => <li key={c}>{c}</li>)}</ul></div>
      </div>
    </div>
  </div>
));

const Contact = () => {
  const [copied, setCopied] = useState(false); const email = "karanveerkvr@gmail.com";
  const handleCopy = () => { const ta = document.createElement('textarea'); ta.value = email; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); setCopied(true); setTimeout(() => setCopied(false), 2000); } catch (err) { console.error('Failed to copy text: ', err); } document.body.removeChild(ta); };
  return (
    <section id="contact" className="h-screen flex flex-col items-center justify-center p-6 sm:p-8 text-center bg-black">
      <h2 className="text-2xl sm:text-3xl font-medium text-gray-300 mb-8">// GET IN TOUCH</h2>
      <p className="text-base md:text-lg mb-4 max-w-xl mx-auto text-gray-400">I'm currently open to new opportunities. Feel free to reach out.</p>
      <div className="relative mb-8"><button onClick={handleCopy} className="flex items-center space-x-2 bg-gray-900 border border-gray-800 rounded-md px-4 py-2 text-gray-300 hover:bg-white hover:text-black transition-colors duration-300">{copied ? <CheckIcon className="text-green-500" /> : <ClipboardIcon />}<span>{copied ? 'Copied!' : email}</span></button></div>
      <div className="flex justify-center items-center space-x-6">
        <a href={`mailto:${email}`} className="text-gray-500 hover:text-white p-2 transition-colors"><MailIcon /></a>
        <a href="https://github.com/Karanveerkvr" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white p-2 transition-colors"><GithubIcon /></a>
        <a href="https://www.linkedin.com/in/karanveerkvr/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white p-2 transition-colors"><LinkedinIcon /></a>
      </div>
    </section>
  );
}

// Import the new DownloadPage component


// --- Main App Component ---
export default function App() {
  const horizontalScrollRef = useRef(null);
  const targetRef = useRef(null);
  const [activeHorizontalSection, setActiveHorizontalSection] = useState(0);
  const [activeSection, setActiveSection] = useState('home');
  const horizontalSectionNames = ['Skills', 'Projects', 'Experience', 'Education'];
  const allSectionRefs = { home: useRef(null), about: useRef(null), work: targetRef, contact: useRef(null) };

  // No longer directly scrolling, use RouterLink instead for navigation
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const handleIndicatorClick = (index) => {
    if (window.innerWidth < 768) return;
    const target = targetRef.current; if (!target) return;
    const scrollableHeight = target.offsetHeight - window.innerHeight;
    const progress = index / (horizontalSectionNames.length - 1);
    window.scrollTo({ top: target.offsetTop + (progress * scrollableHeight), behavior: 'smooth' });
  };

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => { entries.forEach((entry) => { if (entry.isIntersecting) setActiveSection(entry.target.id); }); }, { rootMargin: '-50% 0px -50% 0px' });
    Object.values(allSectionRefs).forEach(ref => { if (ref.current) observer.observe(ref.current); });

    const target = targetRef.current; const horizontalSection = horizontalScrollRef.current;
    if (!target || !horizontalSection) return;

    const handleScroll = () => {
      if (window.innerWidth < 768) {
        horizontalSection.style.transform = `translateX(0px)`;
        return;
      };

      const { top, height } = target.getBoundingClientRect();
      const horizontalScrollWidth = horizontalSection.scrollWidth - window.innerWidth;
      const scrollableHeight = height - window.innerHeight;
      if (top <= 0 && top > -scrollableHeight) {
        const progress = -top / scrollableHeight;
        const translateX = progress * horizontalScrollWidth;
        horizontalSection.style.transform = `translateX(-${translateX}px)`;
        const currentSectionIndex = Math.min(horizontalSectionNames.length - 1, Math.floor(progress * horizontalSectionNames.length));
        setActiveHorizontalSection(currentSectionIndex);
      } else if (top > 0) {
        horizontalSection.style.transform = `translateX(0px)`;
        setActiveHorizontalSection(0);
      } else {
        horizontalSection.style.transform = `translateX(-${horizontalScrollWidth}px)`;
        setActiveHorizontalSection(horizontalSectionNames.length - 1);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
      Object.values(allSectionRefs).forEach(ref => { if (ref.current) observer.unobserve(ref.current); });
    };
  }, [horizontalSectionNames.length]);

  return (
    <Router> {/* Wrap your entire app with BrowserRouter */}
      <CursorSparkles />
      {/* ScrollIndicator and Header remain, but Header will use RouterLink for home */}
      <ScrollIndicator sections={horizontalSectionNames} activeIndex={activeHorizontalSection} onIndicatorClick={handleIndicatorClick} />
      <style>{` 
                html {
                    scroll-behavior: smooth;
                    scroll-padding-top: 5rem; /* Adjust this to your header's height */
                }
                body::-webkit-scrollbar { display: none; } 
                body { -ms-overflow-style: none; scrollbar-width: none; background-color: #000000;} 
                @keyframes glow { 0%, 100% { text-shadow: 0 0 10px rgba(255,255,255,0.2), 0 0 20px rgba(255,255,255,0.2); } 50% { text-shadow: 0 0 20px rgba(255,255,255,0.4), 0 0 30px rgba(255,255,255,0.4); } } 
            `}</style>

      {/* Header will now handle navigation slightly differently to integrate with Router */}
      <Header scrollToSection={scrollToSection} activeSection={activeSection} />

      <main className="bg-black text-gray-300 font-mono">
        <Routes> {/* Define your routes here */}
          <Route path="/download-irl-quest" element={<DownloadPage />} /> {/* New route for download page */}
          <Route path="/" element={
            <> {/* This fragment contains your existing portfolio sections */}
              <div ref={allSectionRefs.home} id="home"><Hero /></div>
              <div ref={allSectionRefs.about} id="about"><About /></div>
              <section id="work" ref={targetRef} className="relative h-auto md:h-[400vh]">
                <div className="md:sticky top-0 h-auto md:h-screen flex items-start md:items-center overflow-hidden">
                  <HorizontalSection ref={horizontalScrollRef} data={portfolioData} />
                </div>
              </section>
              <div ref={allSectionRefs.contact} id="contact"><Contact /></div>
            </>
          } />
        </Routes>
      </main>
    </Router>
  );
}